import React, { forwardRef } from "react";
import { Link } from "react-router-dom";
import { FiLoader } from "react-icons/fi";
import classNames from "./classNames";

const Button = forwardRef(
  (
    {
      children,
      className,
      variant = "primary",
      size = "medium",
      fullWidth = false,
      loading = false,
      loadingLabel = "Please wait",
      iconOnly = false,
      to,
      href,
      disabled = false,
      type = "button",
      ...props
    },
    ref
  ) => {
    const classes = classNames(
      "button",
      `button--${variant}`,
      `button--${size}`,
      fullWidth && "button--full-width",
      loading && "button--loading",
      iconOnly && "button--icon-only",
      className
    );

    const content = (
      <>
        {loading && <FiLoader className="button__spinner" aria-hidden="true" />}
        <span className={loading ? "button__label button__label--loading" : "button__label"}>
          {loading ? loadingLabel : children}
        </span>
      </>
    );

    if (to && !disabled && !loading) {
      return (
        <Link ref={ref} className={classes} to={to} {...props}>
          {content}
        </Link>
      );
    }

    if (href && !disabled && !loading) {
      return (
        <a ref={ref} className={classes} href={href} {...props}>
          {content}
        </a>
      );
    }

    return (
      <button
        ref={ref}
        className={classes}
        type={type}
        disabled={disabled || loading}
        aria-busy={loading || undefined}
        {...props}
      >
        {content}
      </button>
    );
  }
);

Button.displayName = "Button";

export default Button;
